<template>
  <div class="avatar-container">
    <div class="badge">
      <div class="has-s-heading-size level">{{ level }}</div>
    </div>
    <div class="profile-image">
      <img :src="imageUrl" />
    </div>
  </div>
</template>

<script>
import {ref, onUpdated} from '@vue/composition-api'

const avatarImages = {
  1: require('../assets/images/Avatar.svg'),
  2: require('../assets/images/Avatar.svg'),
  3: require('../assets/images/Avatar.svg'),
}

export default {
  props: {
    level: {type: Number, required: true},
  },
  setup (props) {
    const imageUrl = ref(avatarImages[props.level])

    onUpdated(() => {
      imageUrl.value = avatarImages[props.level]
    })

    return {
      imageUrl,
    }
  },
}
</script>

<style scoped lang="scss">
.avatar-container {
  position: relative;

  .badge {
    position: absolute;
    left: -8px;
    top: -8px;
    width: 40px;
    height: 40px;
    border-radius: 100%;
    color: variables.$color-black;
    background-color: variables.$color-yellow;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .profile-image {
    width: 83px;
    height: 83px;
    border-radius: 100%;
    overflow: hidden;
    box-shadow: 4px 4px 4px #2C2C2C29;
    background: linear-gradient(180deg, #5B4E98 0%, #F59DB2 100%);

    > img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}
</style>
